import { TrialInterval } from '@types';
import { SiteConfig } from './SiteConfig';

type DateMask = 'DM' | 'DMY' | 'MY' | 'Y';

const maskOptions: Record<DateMask, Intl.DateTimeFormatOptions> = {
  DM: { day: 'numeric', month: 'long' },
  DMY: { day: 'numeric', month: 'long', year: 'numeric' },
  MY: { month: 'long', year: 'numeric' },
  Y: { year: 'numeric' },
};

export const dateFormatter = (date: string | Date, mask: DateMask): string => {
  const { locale } = SiteConfig.getConfig();
  const options = maskOptions[mask] || maskOptions.DMY;
  return new Date(date).toLocaleString(locale, options);
};

const getUTCDateComponents = (inputDate: string | Date): number[] => {
  const date = typeof inputDate === 'string' ? new Date(inputDate) : inputDate;
  return [
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
    date.getUTCMilliseconds(),
  ];
};

export const addMonthsUTC = (date: string | Date, months: number): Date => {
  const [year, month, day, hours, minutes, seconds, milliseconds] = getUTCDateComponents(date);
  const result = new Date(Date.UTC(year, month + months, day, hours, minutes, seconds, milliseconds));

  if (result.getUTCDate() !== day) {
    result.setUTCDate(0);
  }

  return result;
};

export const addDaysUTC = (date: string | Date, days: number): Date => {
  const [year, month, day, hours, minutes, seconds, milliseconds] = getUTCDateComponents(date);
  const result = new Date(Date.UTC(year, month, day + days, hours, minutes, seconds, milliseconds));

  return result;
};

export const addFreeTrialDates = (date: Date, amount: number, units: TrialInterval): string => {
  const dateProcessor = units === TrialInterval.DAY ? addDaysUTC : addMonthsUTC;
  const newDate = dateProcessor(date, amount);
  const result = dateFormatter(newDate, 'DM');

  return result;
};
